import React from "react";
import { Button, Card, CardContent } from "@material-ui/core";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { Link } from "react-router-dom";


const TestimonialCard = ({ quote, author, company }) => {
  return (
    <Card className="testimonial-card dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white">
      <CardContent className="quote-icon">
        <FormatQuoteIcon />
        <p className="quote dark:text-white">{quote}</p>
        <div className="author-info">
          <p className="author dark:text-white">{author}</p>
          <p className="company dark:text-[#6B7280]">{company}</p>
        </div>
      </CardContent>
    </Card>
  );
};

const TestimonialPage = () => {
  return (
    <div className="help-box dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white">
      <h2>Need help choosing?</h2>
      <p>
        Contact our sales team for custom enterprise solutions or assistance.
      </p>

      <div className="button-group mt-20">
        <Link to="/">
          <Button variant="outlined" className="outline-button dark:text-white">
            Contact Sales
          </Button>
        </Link>
        <Link to="/">
          <Button variant="outlined" className="outline-button ml-12 dark:text-white">
            Return to Dashboard
          </Button>
        </Link>
      </div>

      <div className="testimonial-grid dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white">
        <TestimonialCard
          quote="Pro Teams has revolutionized how we manage our business. The ROI was instant."
          author="Sarah Johnson"
          company="Tech Solutions Inc."
        />
        <TestimonialCard
          quote="The best investment we made for our operations. Customer support is exceptional."
          author="Michael Chen"
          company="Global Services Ltd."
        />
      </div>
    </div>
  );
};

export default TestimonialPage;
